import React from 'react';
import { motion } from 'framer-motion';
import ReactImg from '../../../src/images/react.png'
import AuthImg from '../../../src/images/auth.png'
import JsImg from '../../../src/images/js.png'
import { Link } from 'react-router-dom';
import './Blog.css'

const Blog = () => {
    const blogInfo = [
        {
            id: 1,
            topic: "react",
            title: 'new react v18.0',
            des: "React lets you build user interfaces out of individual pieces called components. Create your own React components like Thumbnail, LikeButton, and Video. Then combine them into entire screens, pages, and apps.",
            author: 'nasim',
            date: "29 Mar, 2023",
            img: ReactImg,
        },
        {
            id: 2,
            topic: "firebase",
            title: 'firebase auth in react project',
            des: "Firebase is an app development platform that helps you build and grow apps and games users love. Backed by Google and trusted by millions of businesses around the world.",
            author: 'nasim',
            date: "24 Feb, 2023",
            img: AuthImg,
        },
        {
            id: 3,
            topic: "javascript",
            title: 'Object Oriented Programming in JavaScript ',
            // img: <FaJsSquare className='social-icon text-warning' />,
            des: "JavaScript is not a class-based object-oriented language. But it still has ways of using object oriented programming (OOP).",
            author: 'nasim',
            date: "15 Jan, 2023",
            img: JsImg,
        },
    ]
    return (
      
        <div className="blog-section py-5">
            <div className="container">
                <div className='text-center mb-5'>
                    <h2 className='heading-two'>latest blog</h2>
                    <p><span className='text-uppercase text-light'>my</span> <span className='text-capitalize heading-three'>Articles and Advice</span></p>

                </div>
                <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                    {
                        blogInfo.map(info => <div class="col ">
                            <div class="card h-100 text-light blog-card">
                                <img src={info.img} class="card-img-top rounded p-3" alt="..." />
                                <div class="card-body">
                                    <h6 class="card-title text-capitalize">{info.topic}</h6>
                                    <h3 className="cart-title text-color py-2 text-capitalize">{info.title}</h3>
                                    <p class="card-text">{info.des}</p>
                                    <Link to='/contact' className='btn btn-portfolio my-3'><span>READ MORE</span></Link>
                                </div>
                                <div class="card-footer d-flex justify-content-between">
                                    <small class="text-body-secondary text-capitalize">{info.author}</small>
                                    <small class="text-body-secondary">{info.date}</small>
                                </div>
                            </div>
                        </div>)
                    }
                </div>
                <div className="text-center py-5">
                    <Link to='/' className="btn btn-portfolio mx-auto"><span>VIEW MORE</span> </Link>
                </div>
            </div>
        </div>
    );
};

export default Blog;